import { defineComponent as _defineComponent } from 'vue'
import { ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";
import { PropType, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
	/**
	 * 入力内容。
	 */
	modelValue: {
		type: String,
		required: true,
	},
	/**
	 * テキストエリアとして表示する行数。
	 */
	rows: {
		type: Number,
		required: false,
		default: 5,
	},
	/**
	 * テキストエリアとして表示する列数。
	 */
	cols: {
		type: Number,
		required: false,
		default: 20,
	},
	/**
	 * テキストエリア内のプレースホルダー内容。
	 */
	placeholder: {
		type: String,
		required: false,
		default: "",
	},
	/**
	 * 入力出来る最長文字列。
	 */
	maxlength: {
		type: Number,
		required: true,
	},
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
	/**
	 * テキストエリアに直接適用するクラス名。
	 * 標準のテキストエリアCSSに+αでカスタムしたいときに指定。
	 */
	customClass: {
		type: String,
		required: false,
		default: "",
	},
	/**
	 * 入力対象の識別子。
	 * APIバリデーションエラー時に使用するため、APIバリデーションエラー値と同値にすること。
	 * 例: `Contents`, `Reply.Contents`
	 */
	name: {
		type: String,
		required: true,
	},
	/**
	 * APIバリデーションエラーViewModel。
	 */
	apiValidationErrorViewModel: {
		type: Object as PropType<ApiValidationErrorViewModel | null>,
		required: true,
		default: null,
	},
	/**
	 * 入力必須エラーを表示するかどうか。
	 */
	showRequiredError: {
		type: Boolean,
		required: false,
		default: false,
	},
	/**
	 * テキストエリアのラベル名。
	 */
	label: {
		type: String,
		required: false,
		default: "",
	},
},
  setup(__props, { expose }) {
  expose()

const props = __props
/**
 * カスタマイズされたtextarea要素。
 * バリデーションエラー表示にも対応。
 * 本プロジェクト内部でtextarea要素を利用する場合は、原則このコンポーネントを使用する事。
 */



/**
 * テキストエリアにデフォルト設定されるクラス名。
 */
const defaultClass = "revico-community-talk-custom-textarea";

const errorMessage = computed(() => {
	if (!props.apiValidationErrorViewModel) return "";
	const targets = props.apiValidationErrorViewModel.details.filter((e) => e.target === props.name);
	return targets.map((e) => e.message).join(", ");
});

const __returned__ = { props, defaultClass, errorMessage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})